import React from "react";
import { useTranslation } from "react-i18next";

const TermsAndConditionsSwedenContent = () => {
  const { t } = useTranslation("common");
  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="ukModalDetails">
          <p>{t("termsConditionModalSweden.paragraph1")}</p>
          <p>{t("termsConditionModalSweden.paragraph2")}</p>
          <p>{t("termsConditionModalSweden.paragraph3")}</p>
          <p>{t("termsConditionModalSweden.paragraph4")}</p>
          <p>{t("termsConditionModalSweden.paragraph5")}</p>
          <p>{t("termsConditionModalSweden.paragraph6")}</p>
          <p>{t("termsConditionModalSweden.paragraph7")}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsSwedenContent;
